/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sea_Large_Lynx_CuddleInputs */

const en_sea_large_lynx_cuddle = /** @type {(inputs: Sea_Large_Lynx_CuddleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search segment selectors...`)
};

const de_sea_large_lynx_cuddle = /** @type {(inputs: Sea_Large_Lynx_CuddleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment-Selektoren durchsuchen...`)
};

/**
* | output |
* | --- |
* | "Search segment selectors..." |
*
* @param {Sea_Large_Lynx_CuddleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sea_large_lynx_cuddle = /** @type {((inputs?: Sea_Large_Lynx_CuddleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sea_Large_Lynx_CuddleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sea_large_lynx_cuddle(inputs)
	return de_sea_large_lynx_cuddle(inputs)
});